import React, { useCallback } from 'react';

import { Inline } from '@atlaskit/primitives/compiled';
import Toggle from '@atlaskit/toggle';

type FooterProps = {
	isSynced: boolean;
	onSyncedChange?(isSynced: boolean): void;
	testId?: string;
};

/**
 * __Footer__
 *
 * The appearance controls footer.
 */
const Footer = ({ isSynced, onSyncedChange, testId }: FooterProps) => {
	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			onSyncedChange?.(e.target.checked);
		},
		[onSyncedChange],
	);

	return (
		<Inline space="space.025" alignBlock="center">
			<Toggle
				id="apply-to-all-components"
				isChecked={isSynced}
				onChange={handleChange}
				testId={testId ? `${testId}--sync` : undefined}
			/>
			<label htmlFor="apply-to-all-components">Apply to all components</label>
		</Inline>
	);
};

export default Footer;
